import { useNavigate } from 'react-router-dom';
import { Dropdown, Avatar, Space, Typography } from 'antd';
import {
  SearchOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  SwapOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import useAuthStore from '../../../store/authStore';
import useUiStore from '../../../store/uiStore';
import NotificationDropdown from '../../notifications/NotificationDropdown';

const { Text } = Typography;

const TopBar = () => {
  const navigate = useNavigate();
  const { user, currentOrganization, organizations, setCurrentOrganization, logout } = useAuthStore();
  const perms = currentOrganization?.permissions || [];
  const canAdmin = perms.includes('org.manage') || perms.includes('org.manage_members') || perms.includes('org.manage_roles');
  const { setSearchModalOpen } = useUiStore();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const userMenuItems = {
    items: [
      {
        key: 'profile',
        icon: <UserOutlined />,
        label: 'My Profile',
        onClick: () => navigate('/profile'),
      },
      ...(organizations.length > 1
        ? [{
            key: 'switch-org',
            icon: <SwapOutlined />,
            label: 'Switch Organization',
            children: organizations.map((org) => ({
              key: `org-${org.id}`,
              label: org.name,
              onClick: () => setCurrentOrganization(org),
            })),
          }]
        : []),
      {
        key: 'settings',
        icon: <SettingOutlined />,
        label: 'Settings',
        onClick: () => navigate(canAdmin ? '/admin/organization' : '/admin/notifications'),
      },
      { type: 'divider' },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: 'Logout',
        danger: true,
        onClick: handleLogout,
      },
    ],
  };

  return (
    <div className="app-header">
      <div className="header-left">
        <div className="search-trigger" onClick={() => setSearchModalOpen(true)}>
          <SearchOutlined className="search-trigger-icon" />
          <span className="search-trigger-text">Search tickets, pages...</span>
          <kbd className="search-shortcut">Ctrl+K</kbd>
        </div>
      </div>

      <div className="header-right">
        {currentOrganization && (
          <Text type="secondary" style={{ marginRight: 8 }}>
            {currentOrganization.name}
          </Text>
        )}

        <NotificationDropdown />

        <Dropdown menu={userMenuItems} trigger={['click']} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <Avatar
              size="small"
              icon={<UserOutlined />}
              style={{ backgroundColor: '#1B3A5C' }}
            />
            <Text>{user?.displayName || user?.display_name || user?.fullName || user?.full_name || 'User'}</Text>
          </Space>
        </Dropdown>
      </div>
    </div>
  );
};

export default TopBar;
